import { useContext, useEffect, useState } from "react"
import { Button, Icon, Popup } from "semantic-ui-react";
import api from '../../apis/api';
import TableBase from "../TableBase"
import { epochToStringNoT } from "../EpochToString";
import UserContext from "../../contexts/UserContext";
import { defaultOptions } from "../../GlobalStyles/MUIDefaultSettings";
import { useAlertsStore } from "../../store/AlertsStore";
import { useNavigate } from "react-router-dom";
import { icon_name, icon_color, icon_title } from "./IconMatrix";
import AlertsPopup from "./AlertsPopup";
import { ErrorToast } from "../Toasters";

const Alerts = ({ alerts, showSite=true, siteIds=[] }) => {

    const navigate = useNavigate()
    const [assets, setAssets] = useState([])
    const { get_alerts, set_alerts} = useAlertsStore()
    const userContext = useContext(UserContext)

    function reset(id){
        api.put('/alerts/reset', {}, {params: {id: id}}).then(r => {
            let sites = userContext.userInfo.site_list.map(i => i.id)
            if(siteIds.length > 0){sites = siteIds}
            get_alerts(sites, ["TRIGGERED"]).then(r => {
                set_alerts(r.data)
            })
        }).catch(err => ErrorToast(err))
    }

    useEffect(() => {
        if(alerts.length > 0){
            const assetIds = [...new Set(alerts.map(i => i.searchIndex.assetId))]
            api.post('/assets/filtered', { assetId: assetIds.join(",")}).then(r => {
                setAssets(r.data)
            })
        }

    }, [alerts])

    // set color
    defaultOptions.setRowProps = (row) => {
        if(row[6] === 1){
            return {
                style: { background: "#FFCDD2" }
            }
        }
    }

    const inline_style = {
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        display: "block",
        overflow: "hidden"
    }

    alerts = alerts.map(a => {
        let site = userContext.userInfo.site_list.find(i => i.id === a.databaseId)
        a.siteLabel = site.label
        let asset = assets.find(i => i.objectId === a.searchIndex.assetId)
        if(asset){
            a.assetId = asset.objectId
            a.assetName = asset.searchIndex.assetName
        }
        a.message = a.searchIndex.message
        a.severity = a.searchIndex.severity
        a.datetime = a.searchIndex.datetime
        a.ticketNumber = a.searchIndex.ticketNumber
        return a
    })

    const columns = [
        {name: "assetId", label: "Asset ID", options: {display: false}},
        {name: "id", label: "Action", options: {
            display: userContext.userInfo.teams.includes("GridSec")? true: false,
            customBodyRender:(v) => <AlertsPopup callback={() => reset(v)} />
        }},
        {name: "assetName", label: "Asset", options: {customBodyRender:(v, meta) => {
            let asset = assets.find(i => i.objectId === meta.rowData[0])
            if(asset){
                let site = userContext.userInfo.site_list.find(i => i.id === asset.databaseId)
                return <span style={inline_style}>
                    <Icon name={icon_name[asset.searchIndex.nodeClass]} color={icon_color[asset.searchIndex.offline]} title={icon_title[asset.searchIndex.nodeClass]} />
                    <a onClick={(e) => {e.preventDefault(); navigate(`/organization/${site.owner}/${site.label}/asset/${asset.objectId}`)}} href={`/organization/${site.owner}/${site.label}/asset/${asset.id}`} style={{cursor: "pointer"}}>{asset.searchIndex.assetName}</a>
                </span>
            }
            // return v
            }
        }},
        {name: "datetime", label: "Date", options: {customBodyRender:(v) => <span style={{display: "inline"}}>{epochToStringNoT(v)}</span>}},
        {name: "siteLabel", label: "Site", options: {display: showSite, customBodyRender:(v) => {
            let site = userContext.userInfo.site_list.find(i => i.label === v)
            return <a style={{cursor: "pointer"}} onClick={(e) => {e.preventDefault(); navigate(`/organization/${site.owner}/${site.label}`)}} href={`/organization/${site.owner}/${site.label}`}>{v}</a>
        }}},
        {name: "message", label: "Message", options: {customBodyRender: (v) => <div>
            <Popup
                trigger={<span>{v.length > 85?v.slice(0, 85) + "...": v}</span>}
                wide="very"
                position="down"
                
            >
                <Popup.Content>
                    {v}
                </Popup.Content>
            </Popup>
            
        </div>}},
        {name: "severity", label: "Severity"},
        {name: "ticketNumber", label: "Ticket #", options: {customBodyRender: (v) => <a href={`/tickets/details/${v}`} target="_blank">{v}</a>}},
    ]

    return <TableBase
        data={alerts}
        columns={columns}
        options={defaultOptions}
    />

}

export default Alerts